module.exports = __webpack_public_path__ + "img/bagels_cooked.474ded67.jpg";